import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class FacilitatorGuard  {
    constructor(private auth: AuthenticationService, private router: Router) { }

    /* eslint-disable @typescript-eslint/no-unused-vars */
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
            const roles = this.auth.getUserRoles();
            if (roles.includes('admin') || roles.includes('restrictedadmin') || roles.includes('facilitator')) {
                // Facilitator view (programs-external/:id/:type) only has the Classes tab
                const type = next.paramMap.get('type');
                if (type !== null && type !== 'classes') {
                    return this.router.createUrlTree(['/error/404']);
                }
                return true;
            }
            return roles.length ? this.router.createUrlTree(['/error/404']) : false;
    }
    /* eslint-enable @typescript-eslint/no-unused-vars */

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.canActivate(route, state);
    }
}
